import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom'; 
import { CssBaseline } from '@mui/material';

import MainNavBar from './components/MainNavBar';
import ActivityFooter from './components/ActivityFooter';
import BookingForm from './components/BookingForm';
import OperatorDashboard from './components/OperatorDashboard';
import ManagementDashboard from './components/ManagementDashboard';
import ResourceManagement from './components/ResourceManagement';
import LoginPage from './components/LoginPage';

const PrivateRoutes = () => {
    const token = localStorage.getItem('access_token');
    return token ? (
        <>
            <MainNavBar />
            <Outlet />
            <ActivityFooter />
        </>
    ) : <Navigate to="/login" replace />;
};

function App() {
  return (
      <div className="app-background"> 
        <CssBaseline />

        <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route element={<PrivateRoutes />}>
                <Route path="/" element={<BookingForm />} />
                <Route path="/form" element={<BookingForm />} />
                <Route path="/dashboard" element={<OperatorDashboard />} />
                <Route path="/management" element={<ManagementDashboard />} />
                <Route path="/resources" element={<ResourceManagement />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
  );
}

export default App;